'use client';

import { twMerge } from '@shared/themes';
import { PurchaseSummary } from '../../PurchaseSummary/PurchaseSummary';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsOrderSummaryProps = {
  className?: string;
};

/**
 * Renders the order summary (order id, submission date, duration, draws).
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsOrderSummary({ className }: PurchaseDetailsOrderSummaryProps) {
  const { ticket, numberOfDraws } = usePurchaseDetails();
  const { orderId, submissionDate, duration, renewType } = ticket;

  return (
    <PurchaseSummary
      orderId={orderId}
      submissionDate={submissionDate}
      duration={duration}
      renewType={renewType}
      numberOfDraws={numberOfDraws}
      className={twMerge('ll-container-inner', className)}
    />
  );
}

export { PurchaseDetailsOrderSummary, type PurchaseDetailsOrderSummaryProps };
